
import { of as observableOf,  Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Country } from '../models/country.model';
import { SETTINGS } from '../../app.constants';
import { LanguageDataHash } from '../models/reference-data/language-data-hash.interface';
import { ReferenceDataModel } from '../models/reference-data/reference-data.model';
import { CodeName } from '../models/reference-data/code-name.model';
import { CodeNameHash } from '../models/reference-data/code-name-hash.interface';
import { environment } from '../../../environments/environment';

@Injectable()
export class ReferenceService {

    private _data : LanguageDataHash = {};
    private _currentReferenceData:ReferenceDataModel;

    constructor(private http : HttpClient) {}

    /**
     * For changing out language specific data. You must initalize TranslateService with initPullData first
     */
    pullData() : Observable<ReferenceDataModel> {

        if(this._currentReferenceData) {
            // return cache
            return observableOf(this._currentReferenceData);
        } else {
            // if the current language did change, set it up for the new data
            //this._langKey = this.translateService.currentLang;
            //console.error('TranslateReferenceService Language reference data not implemented');
            return observableOf(null);
            //throw new Error("Language reference change not implemented");
        }

     }

    // APP_INITIALIZER requires a funciton to return a promise.. Observables do not work.
    // To ensure the reference data is loaded before the app initializes, this will be used.    
    initPullData() : Promise<ReferenceDataModel> {

        if(this._data['en']) {
            throw new Error('ReferenceService, you should not call initPullData twice, use pullData instead');
        }

        let uri:string;
        if(environment.useStaticAPIData) {
            uri = SETTINGS.staticTestAPIRoot + 'reference-data.json';
        } else {
            uri = environment.uriTTPEndpoint + environment.apiVersion + 'goesapp/reference/data?lang=en';
        }

        // var promise:Promise<any> =  this.http.get(uri)
        //     .map(res =>res.json()).toPromise()
        //     .catch(error=> observableThrowError('Server error').toPromise());

        // promise.then(res => {
        //     this._data['en'] = new ReferenceDataModel(res);
        //     this._currentReferenceData = this._data['en'];
        // });

        const promise = new Promise<any>((resolve, reject) => {
            this.http.get(uri).pipe()
            .toPromise()
            .catch( reject )
            .then(
                res => {
                    this._data['en'] = new ReferenceDataModel(res);
                    this._currentReferenceData = this._data['en'];

                    resolve(this._currentReferenceData);
                }
            );
        });

        return promise;
    }

     // todo: type this better? 
     getRef(path : string):any {
         return path.split('.').reduce(function(prev, curr){
             return prev ? prev[curr] : undefined;
             }, this._currentReferenceData.srcData || self);
     }

     getCountries() : Country[] {
         return this._currentReferenceData.countryList;
     }

     // todo: maybe we should create a hashmap of countries instead if this gets used a lot? 
     getCountryByIsoCode(isoCode:string) : Country {
         let country:Country = this._currentReferenceData.getCountryByIsoCode(isoCode.trim());
         return country;
     }

     getStatenameByCountryAndStateISO(countryISOCode: string, stateCode: string): string {
         return this._currentReferenceData.getStateNameByCountryAndStateISOCode(countryISOCode.trim(), stateCode.trim());
     }

    //  getBirthCountries() : Country[] {
    //      let countries:Country[] = this._currentReferenceData.birthCountryList;
    //      return countries;
    //      //return this.countryList.filter(country => country.isForBirth == true)
    //      //return this.birthCountryList; 
    //  }

    //  getCitCountries() : Country[] {
    //     let countries:Country[] = this._currentReferenceData.citizenshipCountryList;
    //     return countries;
    //     //return this.countryList.filter(country => country.isForCitizenship == true);
    //     //return this.citCountryList;
    //  }

    //  getAddressCountries() : Country[] {
    //     let countries:Country[] = this._currentReferenceData.addressCountryList;
    //     return countries;
    //     //return this.countryList.filter(country => country.isForCurrentAddress); 
    //     //return this.countryList;
    //  }

    //  getVisaClasses(): VisaClass[] {
    //     return this._currentReferenceData.visaClasses;
    //  }

     // todo: make stronger type return
     getData() : any {
        if(!this._currentReferenceData) {
            throw new Error('The reference data for this language is not available. Did you call the service yet?');
        }
        return this._currentReferenceData.srcData;
     }

     getApplicationStatus(code: string): CodeName {
        let statuses:CodeNameHash = this._currentReferenceData.applicationStatuses;
        let status:CodeName = statuses[code];
        return status;
     }

     getProgramName(code: string): string {
         try {
            var program = this._currentReferenceData['programInfo'][code];
             return program['programName'];
         } catch(e) {
             //console.warn('TranslateReference getProgramName could not find programInfo with '+code);
         }
         return code;
     }

     getApplicationType(code: string): string {
         if(this._data) {
             var types:any = this._currentReferenceData['applicationTypes'];
             for(let type of types){
                 if(type['code'] === code) {
                     return type['name'];
                 }
             }
         }
         return code;
     }

}
